var _metadata, _g, _path, _path2, _path3, _path4, _desc;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcformat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dctype", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "42.667px",
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect24208)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.1764 0 0 2.1764 52.747 73.876)",
    fill: "#686de0",
    style: {
      shapeInside: "url(#rect24218)",
      whiteSpace: "pre"
    },
    "aria-label": "FLA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-22.029-9.867h17.639v8.0156h-7.224v7.5951h6.4323v7.6198h-6.4323v16.823h-10.415z",
    style: {
      shapeInside: "url(#rect24218)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5488-9.867v32.038h6.3333v8.0156h-16.749v-40.053z",
    style: {
      shapeInside: "url(#rect24218)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.653-9.867 5.9622 40.053h-10.663l-0.51953-7.1992h-3.7357l-0.61849 7.1992h-10.786l5.2943-40.053zm-5.5169 25.754q-0.79167-6.8034-1.5833-16.798-1.5833 11.479-1.9792 16.798z",
    style: {
      shapeInside: "url(#rect24218)"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.1764 0 0 2.1764 -38.077 31.808)",
    fill: "#686de0",
    "aria-label": "IFT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m153.86 9.3917v40.053h-10.415v-40.053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.05 9.3917h17.639v8.0156h-7.224v7.5951h6.4323v7.6198h-6.4323v16.823h-10.415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.19 9.3917v8.0156h-6.1849v32.038h-10.415v-32.038h-6.1602v-8.0156z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m171.16 119.77h-16.223v23.435l16.223 6.5225z",
    fill: "#f39c11",
    stroke: "#f39c11",
    strokeWidth: 0.13801
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m171.16 41.143-16.223 6.5227v63.992h50.927a4.0557 4.0557 0 0 1 2.0223 7.5713l-28.615 16.461v14.037l55.495-31.924a9.7338 9.7338 0 0 0-4.5989-18.313h-50.896a8.1115 8.1115 0 0 1-8.1115-8.1114z",
    fill: "#f39c11",
    stroke: "#f39c11",
    strokeWidth: 0.13801
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m240.1 55.179v-14.037l-55.495 31.923a9.7338 9.7338 0 0 0 4.5989 18.313h50.896a8.1115 8.1115 0 0 1 8.1115 8.1114v50.236l16.223-6.5226v-63.992h-50.927a4.0557 4.0557 0 0 1-2.0224-7.5713z",
    fill: "#f39c11",
    stroke: "#f39c11",
    strokeWidth: 0.13801
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m264.44 47.665-16.223-6.5225v29.698l16.223-2.3e-5z",
    fill: "#f39c11",
    stroke: "#f39c11",
    strokeWidth: 0.13801
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "logo5.dxf - scale = 124.819870, origin = (24.200847, 17.891299), method = auto")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightlogo);
export default __webpack_public_path__ + "static/media/lightlogo.3a248b768b3b084ff92c16a8562ec0f1.svg";
export { ForwardRef as ReactComponent };